import React from 'react';
import Link from 'next/link';

export default function Cta({
  url,
  buttonText = 'Park Here',
  marginTop = 4,
  external = false,
  center = true,
  fullSize = false,
  rel = '',
}) {
  if (!external && typeof url !== 'function') {
    return (
      <Link
        href={url}
        scroll={true}
        data-testid="wrapper"
        rel={rel}
        className={`${
          fullSize ? 'block' : 'table'
        } text-center rounded-full uppercase ${
          center ? 'mx-auto' : ''
        } mt-${marginTop} px-12 bg-primary text-white hover:bg-primary-hover hover:text-white py-3 font-semibold`}
      >
        {buttonText}
      </Link>
    );
  } else if (typeof url === 'function') {
    return (
      <div
        onClick={url}
        className={`table rounded-full uppercase ${
          center ? 'mx-auto' : ''
        } mt-${marginTop} cursor-pointer px-12 bg-primary text-white hover:bg-primary-hover hover:text-white py-3 font-semibold`}
        data-testid="wrapper"
      >
        {buttonText}
      </div>
    );
  } else {
    return (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className={`table rounded-full uppercase ${
          center ? 'mx-auto' : ''
        } mt-${marginTop} px-8 bg-primary text-white hover:bg-primary-hover hover:text-white py-3 font-semibold`}
        data-testid="wrapper"
      >
        {buttonText}
      </a>
    );
  }
}
